// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

/**
 *
 * @param {{
 *  onChange?: import('react').ChangeEventHandler;
 *  variant?: import('./inputVariants').InputVariant;
 *  placeholder?: string;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function TextInput({
  onChange,
  variant = 'default',
  placeholder,
  ...rest
}) {
  return (
    <Text
      as="input"
      // @ts-ignore type="text" is passed to the input DOM elemeent.
      type="text"
      onChange={onChange}
      placeholder={placeholder}
      sx={{
        padding: 2, // This is partially overriden by variants.
        color: 'lightText',
        // Using inset box shadows because the Zeplin designs use inner borders,
        // and I wouldn't have the same total heights otherwise.
        border: 0,
        boxShadow: (theme) => `inset 0 0 0 1px ${theme.colors.border};`,
        variant: `input.${variant}`,
        '::placeholder': { color: 'border' },
      }}
      {...rest}
    />
  );
}
